<template>
  <base-layout>
  <div class="row" v-if="!isActive">
    <div class="col-md-12">
      <div class="col-md-12">
        <ul class=" clearfix list-unstyled list-inline">
          <template>
               <li>
                <span class="circle"></span>
                <span class="span_styles">PENDING LEAVE APPROVAL</span>
              </li>
              <li>
                <span class="circle6"></span>
                <span class="span_styles">REQUESTED FOR EDIT</span>
              </li>
              <li>
                <span class="circle1"></span>
                <span class="span_styles">TIME OFF</span>
              </li>
              <li>
                <span class="circle2"></span>
                <span class="span_styles">APPROVED</span>
              </li>
              <li>
                <span class="circle3"></span>
                <span class="span_styles">PENDING</span>
              </li>
              <li>
                <span class="circle4"></span>
                <span class="span_styles">REJECTED</span>
              </li>
              <li>
                <span class="circle5"></span>
                <span class="span_styles">IN-PROGRESS</span>
              </li>
              <li>
                <span class="circle7"></span>
                <span class="span_styles">INVOICE GENERATED</span>
              </li>
               </template>
        </ul>
      </div>
      <div class="col-md-3" style="margin-right: 0px;padding-right:0px">
        <a style="text-decoration:none;float:right" @click="toggle">Hide Color Codes</a> 
      </div>
    </div>
  </div>
    <div class="timesheet_layout">
      <div class="row" style="margin-right: 0px;">
        <div class="col-md-12">
          <ul class="clearfix list-unstyled list-inline" style="margin: 0px 0px 10px 0px;">
            <ul
              v-show="legend"
              class="clearfix list-unstyled list-inline pull-left"
              style="margin-left: 10px;"
            >
              <li v-if="IsSupervisor">
                <h5 class="h3_styles">
                  <ob-select2 :options="computedTimeSheetOptions()" v-model.trim="TimeSheets"></ob-select2>
                </h5>
              </li>
              <li v-else>
                <h3 class="h3_styles">{{ timesheetLabel }} & Expenses</h3>
              </li>
              <li>
                <h3 class="h3_styles" style="width: 100px;">
                  <ob-date-time-picker
                    id="createDate"
                    placeholder="Select "
                    :options="options1"
                    :inputvalue="Year"
                    @updated="(v) => this.Year = v"
                    v-model.trim="Year"
                  ></ob-date-time-picker>
                </h3>
              </li>
              <li>
                <h5 class="h3_styles">
                  <ob-select2 :options="options" v-model.trim="CalendarView"></ob-select2>
                </h5>
              </li>
            </ul>
            <ul class="pull-right clearfix list-unstyled list-inline" style="margin:0px;">
               <a style="text-decoration:none;color:#000000;"  v-show="isActive" @click="toggle">{{isActive ? 'Show Color Codes ' : 'Hide Color Codes'}}</a>
              <li>
                   <!-- <ob-button :disabled="IsReportGenerationInProgress" type="secondary" @click="generateReport()">
                            <span v-if="IsReportGenerationInProgress" v-tooltip="`${timesheetLabel} report generation is in-progress so please wait till it is completed.`">Generate Report</span>
                            <span v-else>Generate Report</span>
                  </ob-button> -->
                   <ob-dropdown title="Reports">
                        <ob-dropdown-list-item  v-if="!IsReportGenerationInProgress"  style="width:200px"  :disabled="IsReportGenerationInProgress" type="secondary" @click.native="generateReport()">
                          <span>Generate Report</span>
                        </ob-dropdown-list-item>

                        <span v-else v-tooltip="`${timesheetLabel} report generation is in-progress so please wait till it is completed.`">
                          <ob-dropdown-list-item style="width:200px;padding-right:0px"  :disabled="true" :class="{'disable-options': true}">Generate Report</ob-dropdown-list-item>   
                        </span>

                        <ob-dropdown-list-item v-if="IsDCAAComplianceToggleOn" @click.native="activityLog()">Activity Log</ob-dropdown-list-item>
                    </ob-dropdown>

              </li>
              <li>
                <ob-button @click="addTimesheets()">Add {{ timesheetLabel }}</ob-button>
              </li>
            </ul>
            <!-- <ul class="pull-right clearfix list-unstyled list-inline" style="margin-top:10px;">
              <li>
                <span class="circle"></span>
                <span class="span_styles">PENDING LEAVE APPROVAL</span>
              </li>
              <li>
                <span class="circle6"></span>
                <span class="span_styles">EDIT REQUEST</span>
              </li>
              <li>
                <span class="circle1"></span>
                <span class="span_styles">TIME OFF</span>
              </li>
              <li>
                <span class="circle2"></span>
                <span class="span_styles">APPROVED</span>
              </li>
              <li>
                <span class="circle3"></span>
                <span class="span_styles">PENDING</span>
              </li>
              <li>
                <span class="circle4"></span>
                <span class="span_styles">REJECTED</span>
              </li>
              <li>
                <span class="circle5"></span>
                <span class="span_styles">IN-PROGRESS</span>
              </li>
            </ul> -->
          </ul>
        </div>
        <div
          class="col-md-12"
          v-if="CalendarView == 'dayGridMonth'"
          style="overflow: auto; height: 516px;background: #fff;"
        >
          <timesheets-calender
            @hideLegend="hideLegend"
            @changedDate="changedDate"
            ref="timeSheetsCalender"
            :defaultView="CalendarView"
            :calendarPlugins="calendarPlugins"
          ></timesheets-calender>
        </div>

        <div style="overflow:auto;max-height:500px" class="col-md-12" v-else>
          <timesheets-calender
            @hideLegend="hideLegend"
            @changedDate="changedDate"
            ref="timeSheetsCalender"
            :defaultView="CalendarView"
            :calendarPlugins="calendarPlugins"
          ></timesheets-calender>
        </div>
        <div class="col-md-12" v-show="isModalvisible && IsDCAAComplianceToggleOn"  style="background-color:#ffffff;overflow:auto;width:45%;box-shadow:0 0 20px #ddd;padding:2%;position: absolute;bottom: 2%;">
         <i   @click="cancel()" class="fa fa-pull-right fa-close"  style="font-size:18px;"></i>
          <div class="col-md-1 pL0 mL0">
            <!-- <img src="/static/Images/alert.svg" style="width:40px;" /> -->
            <img style="margin-right:5%;padding-top:5px;width:50px" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/alert.svg`"/>
          </div>
          <div class="col-md-8" >
            <p style="font-size: 15px;color:#EF4457;padding-bottom:8px;font-weight: 550;">Missing {{ timesheetLabel }}</p>
            <p style="font-size: 12px;color:black;padding-bottom:8px;font-weight: 550;" v-if="submissionPreferenceType == 'MustBeEnteredOnSameDay'">You haven't submitted today's   ({{this.missingTimesheetDate}}) {{ timesheetLabel.toLowerCase() }}.</p>
                 <p style="font-size: 12px;color:black;padding-bottom:8px;font-weight: 550;" v-else-if="submissionPreferenceType == 'CanBeEnteredOnTheNextDay'">You haven't submitted Yesterday's   ({{this.missingTimesheetDate}}) {{ timesheetLabel.toLowerCase() }}.</p>
                 <p style="font-size: 12px;color:black;padding-bottom:8px;font-weight: 550;" v-else-if="submissionPreferenceType == 'CanBeEnteredInWeeksTime'">You haven't submitted   this week's {{ timesheetLabel.toLowerCase() }}.</p>
                 <p style="font-size: 11px;" v-if="submissionPreferenceType == 'MustBeEnteredOnSameDay'">Note: As per your organization, you should submit your {{ timesheetLabel.toLowerCase() }} everyday.</p>
                 <p style="font-size: 11px;" v-else-if="submissionPreferenceType == 'CanBeEnteredOnTheNextDay'">Note: As per your organization, you should submit your yesterday's {{ timesheetLabel.toLowerCase() }}..</p>
                 <p style="font-size: 11px;" v-else-if="submissionPreferenceType == 'CanBeEnteredInWeeksTime'">Note: As per your organization, you should submit your {{ timesheetLabel.toLowerCase() }} in a Week's Time.</p>
                </div>
          <div class="col-md-3" style="padding-top:4%">
            <ob-button type="primary" @click="addTimesheets()"><span>Add {{ timesheetLabel }}</span></ob-button>
          </div>
        </div>
       </div>
      <div>
        <generate-report :EmployeeId="EmployeeId" :show.sync="showgeneratePopup"></generate-report>
      </div>
    </div>
  </base-layout>
</template>
<script>
import dayGridPlugin from "@fullcalendar/daygrid";
import customViewPlugin from "./Timesheets/Calender/CustomViews/custom-view-yearly.js";

import AddTimesheets from "./Timesheets/AddTimesheets.vue";
import GenerateReport from "./Timesheets/GenerateReport.vue";
import TimeSheetsCalender from "./Timesheets/Calender/TimeSheetsCalender.vue";
export default {
  props: ["TraineeEmployeeId"],
  data() {
    return {
      LegendEmployeeId:'',
      EventIdList:[],
      IsReportGenerationInProgress:false,
      IsSupervisor: false,
      legend: true,
      calendarPlugins: [dayGridPlugin, customViewPlugin],
      TimeSheets: "MyTimeSheets",
      showgeneratePopup: false,
      CalendarView: "dayGridMonth",
      //year: moment().format("YYYY"),
      Year:moment().format("YYYY"),
      month:moment().format('MM'),
      isActive: false,
      timeSheetOptions: {},
      options: {
        minimumResultsForSearch: -1,
        dropdownAutoWidth: true,
        placeholder: {
          id: "-1",
          text: "Select"
        },
        data: [
          {
            id: "dayGridMonth",
            text: "Monthly View"
          },
          {
            id: "customViewYearly",
            text: "Yearly View"
          }
        ]
      },
      options1: {
        format: "YYYY",
        dayViewHeaderFormat: "YYYY",
        ignoreReadonly: true,
        minDate: moment("01/01/1970").format("MM/DD/YYYY"),
        widgetPositioning: {
          // horizontal: 'left',
          vertical: "bottom"
        }
      },
      isModalvisible:false,
      missingTimesheetDate:moment().format("MM/DD/YYYY"),
      missingTimesheetDate1:moment().format("MM/DD/YYYY"),
      submissionPreferenceType:"",
      IsDCAAComplianceToggleOn:false,
    };
  },
  components: {
    "add-timesheets": AddTimesheets,
    "timesheets-calender": TimeSheetsCalender,
    "generate-report": GenerateReport
  },
  watch: {
    showgeneratePopup(val) {
      this.hideLegend(val);
    },
    Year(val) {
  
      this.$refs.timeSheetsCalender.gotoDate(this.Year);
    },
    TimeSheets(val) {
      if (val == "TimeSheets") {
        this.$router.push({ name: "employer-timesheets" });
      } else if (val == "MyTimeSheets") {
        this.$router.push({ name: "my-timesheets" });
      }
    }
  },
  computed: {
    EmployeeId() {
      return this.loggedInUserObj.empId ? this.loggedInUserObj.empId : "";
    },
    
  },
  mounted() {
    events.listen('IsTimesheetInProgress', (val) => {
      this.IsReportGenerationInProgress = val;
    }),
    this.getBannerContent()
  },
  created() {
    this.getSupervisor();
    this.getTimeSheetPreference()
    //  this.fetchMonthlyCalenderEventsDetails()
  },
  methods: {
    computedTimeSheetOptions() {
      debugger
      return {
        minimumResultsForSearch: -1,
        dropdownAutoWidth: true,
        placeholder: {
          id: "-1",
          text: "Select"
        },
        data: [
          {
            id: "TimeSheets",
            text: `${this.timesheetLabel} & Expenses`
          },
          {
            id: "MyTimeSheets",
            text: `My ${this.timesheetLabel} & Expenses`
          }
        ]
      };
    },
    getTimeSheetPreference(){
      this.$loading({'loadingText': 'Loading...'}) 
        ajax.get(`TimeSheets/Settings?orgId=${this.loggedInUserObj.orgId}`, {} , (res) => {
              this.IsDCAAComplianceToggleOn = res.data.TimesheetSettings.DCCACompliance
              this.submissionPreferenceType = res.data.TimesheetSettings.TimesheetSubmissionPrefference
            })
            if(this.IsDCAAComplianceToggleOn){
              this.getBannerContent()
            }
    },
    getSupervisor() {
      ajax.get(`Supervisor/IsSupervisor?empId=${loggedInUserObj.empId}`, {}, res => {
        if (res.data) this.IsSupervisor = res.data;
      });
    },
    hideLegend(val) {
      this.legend = !val;
    },
    addTimesheets() {
      this.$router.push({ name: "employee-addtimesheets" });
      // this.$loading({ 'loadingText': 'Loading...' })
      // var routerPush = this.$router.resolve({name: `employee-addtimesheets`})
      // setTimeout(() => {
      //   this.$loading({}).close()
      // }, 600)
      // window.open(routerPush.href, "_self")
    },
    changedDate(v) {
     this.Year = moment(v).format("YYYY");
      this.month = moment(v).format("MM")
    },
    generateReport() {
      this.showgeneratePopup = true;
    },
     cancel(){
     this.submissionPreferenceType=true
     this.isModalvisible = false;
    },
     toggle() {
      this.isActive = this.isActive ? false : true;
      },
  activityLog(){
      this.$router.push({path:`dcaa-reports`})
     //this.$router.push({ name: "employee-activitylog" });
   },

   EnumerateDaysBetweenDates(startDate, endDate) {
      var now = startDate,
        dates = [];
     
        while (now.isSameOrBefore(endDate)) {
        dates.push(now.format("MM/DD/YYYY"));
        now.add(1, "days");
        
      }  
      return dates;
    },

  getBannerContent(){ 
      var _this = this;
      var year = moment().format('YYYY')
      var month = moment().format("MM")
       ajax.get(
          `/TimeSheets/Employee/Monthly/List/${this.EmployeeId}?month=${month}&year=${year}`,
          {},
          res => {
            var date1 = moment().format('MM/DD/YYYY');
            var date2 = moment().format('MM/DD/YYYY');

            if(_this.submissionPreferenceType == 'MustBeEnteredOnSameDay'){
              date1 = moment().format('MM/DD/YYYY')
            }
            else if(_this.submissionPreferenceType == 'CanBeEnteredOnTheNextDay'){
              date1 = moment(date1).subtract(1, "days").format('MM/DD/YYYY');
              date2 = date1;
            }
            else if(_this.submissionPreferenceType == 'CanBeEnteredInWeeksTime'){
               date1 = moment().startOf('isoweek').format('MM/DD/YYYY');
               date2 = moment().endOf('week').subtract(1, "days").format('MM/DD/YYYY');     
            }
            var range = this.EnumerateDaysBetweenDates(moment(date1), moment(date2));

            var timesheetDateList = res.data.CalendarList.flatMap(m=>m.HoursPerDay).filter(v=>v != null).map(h=>h.Date);
            
            var remainedDates = range.filter(n => !timesheetDateList.includes(n));

            if(remainedDates.length > 0){
              _this.isModalvisible = true
              _this.missingTimesheetDate = moment(date1).format('MM/DD/YYYY')
            }
            this.$loading({}).close();
          }
        );
  
    },
  }
};
</script>
<style lang="scss" scoped>
.timesheet_layout {
  height: 100%;
  overflow: auto;
}
.circle {
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color: #000000;
  background-color: #000000;
}
.circle1 {
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color: #2027e8;
  background-color: #2027e8;
}
.circle2 {
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color: #13da7c;
  background-color: #13da7c;
}
.circle3 {
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color: #f8d21c;
  background-color: #f8d21c;
}
.circle4 {
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color: #ef4457;
  background-color: #ef4457;
}
.circle5 {
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color: #F96301;
  background-color: #F96301;
}
.circle7 {
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color: #A31D95;
  background-color: #A31D95;
}
.span_styles {
  color: #000000;
  font-weight: 600;
  font-size: 12px;
}
.h3_styles {
  color: #000000;
  font-weight: 600;
}
.circle6{
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color:#aa99d6;
  background-color:#aa99d6;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/MyTimesheets.vue